<template>
  <div :id="uuid" ref="container" :style="style"></div>
</template>



<script>

import * as echarts from 'echarts';
import {v4 as uuidv4} from 'uuid';

let cores = ['#c23531','#2f4554', '#61a0a8', '#d48265', '#91c7ae','#749f83',  '#ca8622', '#bda29a','#6e7074', '#546570', '#c4ccd3'];

// const ECharts = window.echarts || undefined;

/* eslint-disable no-alert, no-console */
function valorBR(params) {
  return params.value.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2, })
}
export default {
  name: 'BarChart',

  props: {
    dados: {
      type: Object,
      default: () => {}
    },
    selecionados: {
      type: Object,
       default: () => {
        return {};
      }
    },

    height: {
      type: String,
      default: '450px'
    }
  },

  data: () => ({
    myChart: {},
    options: {},
    uuid: null
  }),

  computed: {
    style() {
      return {
        height: this.height,
        width: '100%'
      }
    }
  },

  created() {
    this.uuid = uuidv4();
  },

  mounted () {
    this.init();
  },

  umounted() {
    window.removeEventListener('resize', this.resize);
  },

  methods: {
    init() {
      // const dom = this.$refs.container;
      const dom = document.getElementById(this.uuid);
      this.myChart = echarts.init(dom);
      this.options = this.getOptions();
      this.myChart.setOption(this.options, true);

      window.addEventListener('resize', this.resize);
    },

    getOptions() {
      function formatter(value, decimal = 2, currency) {
        let formattedValue = Number(value).toLocaleString("pt-BR", {
                minimumFractionDigits: decimal,
                maximumFractionDigits: decimal,
                style: !!currency ? 'currency' : undefined, 
                currency: currency
              });

        if (decimal === 0) {
          formattedValue = formattedValue.replace('.', '');
        }

        return formattedValue;
      }

      const options = {
        legend: {
          show: true,
          type: 'scroll',
          orient: 'horizontal',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          },
          formatter: function (params) {
            let html = params[0].name + "<br/>";

            params.forEach(function (item) {
              let valorFormatado = formatter(item.value, 2, 'BRL');
              
              if (item.seriesName.includes('Quantidade')) {
                valorFormatado = formatter(item.value, 0);
              }

              html += item.marker + item.seriesName + ": " + valorFormatado + "<br/>";
            });

            return html;
          },
        },
        color: ['#C23531','#FAC858', '#748EDE'],
        toolbox: {
          bottom: 'bottom',
          left: 'center',
          show: true,
          showTitle: true,
          feature: {
            dataZoom: {
              yAxisIndex: 'none',
              title: {
                back: 'Reiniciar Zoom'
              }
            },
            // dataView: {readOnly: false},
            magicType: {
              type: ['line', 'bar'],
              title: {
                line: 'Gráfico de Linhas',
                bar: 'Gráfico de Barras',
              }
            },
            restore: {
              title: 'Restaurar'
            },
            saveAsImage: {
              title: 'Download'
            }
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          axisLabel: {
            fontSize: 10
          },
          data: this.dados.titles
        },
        yAxis: {
          type: 'value',
        },
        series: this.dados.series
      }

      return options;
    },

    resize() {
      this.myChart.resize();
    },
    setData(data) {
      this.options.series = data.series;
      this.options.series.forEach(element => {
        if (element.label.normal.formatter == 'valorBR') 
          element.label.normal['formatter'] = this.valorBR;
      });
      this.options.xAxis.data = data.titles;
      this.myChart.setOption(this.options, true);
    },

    valorBR(params) {
      return params.value.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2, })
    }
  },


  watch: {
    dados(value, oldvalue) {
      this.setData(value);
    //   this.init();
      // this.options.series[0].data = this.serieData;
      // this.options.xAxis.data = this.xAxisData;
      // this.options.legend.selected = this.selecionados;
      // this.myChart.setOption(this.options, true);
    }
  },
}
</script>

<style>
</style>